import type { ZoneGeoJsonPoint, ZoneGeoJsonPolygon } from '@chukua/common';

const EARTH_RADIUS_METERS = 6_371_008.8;
const STEPS = 64;

/**
 * A point zone's circle as a polygon, for drawing only: the stored zone stays a centroid and a radius.
 * Each vertex is the destination point at `radiusMeters` along its bearing, so the circle is true on the
 * ground rather than squashed by the map's projection.
 */
export function circlePolygon(center: ZoneGeoJsonPoint, radiusMeters: number): ZoneGeoJsonPolygon {
  const [lng, lat] = center.coordinates.map((degrees) => (degrees * Math.PI) / 180);
  const angular = radiusMeters / EARTH_RADIUS_METERS;
  const ring: [number, number][] = Array.from({ length: STEPS }, (_, step) => {
    const bearing = (2 * Math.PI * step) / STEPS;
    const pointLat = Math.asin(Math.sin(lat) * Math.cos(angular) + Math.cos(lat) * Math.sin(angular) * Math.cos(bearing));
    const pointLng = lng + Math.atan2(Math.sin(bearing) * Math.sin(angular) * Math.cos(lat), Math.cos(angular) - Math.sin(lat) * Math.sin(pointLat));
    return [(pointLng * 180) / Math.PI, (pointLat * 180) / Math.PI];
  });
  return { type: 'Polygon', coordinates: [[...ring, ring[0]]] };
}
